export default __webpack_public_path__ + "static/196-1d4abd21347163322e9a766c89d35422.jpg";